import { useContext } from "react";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";

function useProcessSchema() {
  const { user } = useContext(AuthContext);

  function processSchema(schema: any, element: any): any {
    let processedSchema = { ...schema };

    Object.keys(processedSchema.properties).forEach((key) => {
      let property = processedSchema.properties[key];

      // 1. Filtrado por show
      if (property.hasOwnProperty("show")) {
        if (!property.show) {
          element[key] = property.default;
          delete processedSchema.properties[key];
          return; // Ya eliminado, no seguimos con este campo
        } else {
          delete property.show;
        }
      }

      // 2. Filtrado por roles
      if (property.roles) {
        if (!user || !property.roles.includes(user.role)) {
          element[key] = property.default;
          delete processedSchema.properties[key];
          return; // Ya eliminado, no seguimos con este campo
        } else {
          delete property.roles;
        }
      }

      // 3. Recursividad en objetos
      if (property.type === "object" && property.properties) {
        const newElement = element[key] || {};
        processedSchema.properties[key] = processSchema(property, newElement);
      }

      // 4. Recursividad en arrays de objetos
      if (
        property.type === "array" &&
        property.items &&
        property.items.type === "object" &&
        property.items.properties
      ) {
        const newElement = element[key] || {};
        processedSchema.properties[key].items = processSchema(property.items, newElement);
      }
    });

    return processedSchema;
  }

  return (schema: any, element: any) => {
    return processSchema(schema, element);
  };
}

export default useProcessSchema;
